import useUsagePlan from "src/hooks/useUsagePlan";
import { RootState } from "src/store";
import { useSelector } from "react-redux";

export const getNameInitial = (value?: string) =>
  (value || "").trim().charAt(0).toUpperCase();

export const getMaskedTalentName = (firstName?: string, lastName?: string) => {
  const firstInitial = getNameInitial(firstName);
  const lastInitial = getNameInitial(lastName);

  return [firstInitial, lastInitial]
    .filter(Boolean)
    .map((initial) => `${initial}.`)
    .join(" ");
};

export const useShouldMaskTalentIdentity = () => {
  const usagePlan = useUsagePlan();
  const accountType = useSelector(
    (state: RootState) => state.auth.user?.accountType
  );

  return accountType === "company" && usagePlan === "freemium";
};
